import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b272a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formatting-tenter" }
const _hoisted_2 = { class: "formatting-left" }
const _hoisted_3 = { class: "formatting-right" }



export default /*#__PURE__*/_defineComponent({
  __name: 'formattingText',
  props: {
    leftText:String,
    rightText:String,
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.leftText) + ":", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.rightText), 1)
  ]))
}
}

})